import { Box } from '@squareup/dex-ui-shared-base';
import React, { useMemo, ReactNode } from 'react';

import { ComboboxOption } from './combobox-types';
import styles from './combobox.module.css';

const useFilteredComboboxValues = (
  comboboxValues?: Array<ComboboxOption> | undefined,
  value?: string | undefined
) => {
  return useMemo(() => {
    if (!comboboxValues) {
      return [];
    }

    if (!value) {
      return comboboxValues;
    }

    const searchValue = value.trim().toLowerCase();

    return comboboxValues.filter(
      ({ displayText, value }) =>
        displayText?.toLowerCase().startsWith(searchValue) ||
        value?.toLowerCase().startsWith(searchValue)
    );
  }, [comboboxValues, value]);
};

const useHighlightedComboboxLabel = (
  displayText?: string,
  highlightText?: string
): ReactNode => {
  return useMemo(() => {
    if (!displayText || !highlightText) {
      return displayText;
    }

    const displayTextParts = displayText?.split(
      new RegExp(`(${highlightText})`, 'i')
    );

    return displayTextParts.map((part, index) =>
      part.toLowerCase() === highlightText.toLowerCase() ? (
        <Box as="span" className={styles.highlight} key={index}>
          {part}
        </Box>
      ) : (
        part
      )
    );
  }, [displayText, highlightText]);
};

export { useFilteredComboboxValues, useHighlightedComboboxLabel };
